import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBaseProperties } from "../base";
export const WorkItemProcess = types
  .compose(
    Base,
    types.model({
      workOrderItemId: types.maybeNull(types.string),
      date: types.maybeNull(types.string),
      amount: types.maybeNull(types.number),
    })
  )
  .actions(withSetPropAction);
export interface IWorkItemProcess extends Instance<typeof WorkItemProcess> {}
export interface IWorkItemProcessProperties
  extends SnapshotIn<typeof WorkItemProcess> {}

export interface IAddWorkItemProcess
  extends Omit<IWorkItemProcessProperties, keyof IBaseProperties> {}
export interface IUpdateWorkItemProcess extends IWorkItemProcessProperties {}
